(() => {
  'use strict';
  const configNode = document.getElementById('DonglinBrowseConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const root = (config.root || '/').replace(/\/$/, '');
  const localSource = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol)) return null;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|products|pages|blogs)\//i.test(url.pathname)) return null;
      if (/\/pages\/contact\/?$/.test(url.pathname)) return null;
      if (root && !url.pathname.startsWith(`${root}/`)) return null;
      if (!root && /^\/[a-z]{2}(?:-[a-z]{2})?\//i.test(url.pathname)) return null;
      url.search = '';
      url.hash = '';
      return url;
    } catch { return null; }
  };
  const collectionSource = value => {
    const source = localSource(value);
    return source && /\/collections\//.test(source.pathname) && !/\/products\//.test(source.pathname) ? source : null;
  };
  const contactReferrer = () => {
    try {
      const referrer = new URL(document.referrer);
      return referrer.origin === location.origin && referrer.pathname.replace(/\/$/, '') === `${root}/pages/contact`;
    } catch { return false; }
  };
  const productPath = location.pathname.match(/\/products\/[^/]+/)?.[0];
  const collectionContextKey = `donglin:product-collection:v1:${root}${productPath || location.pathname}`;
  const rememberCollection = source => {
    try { sessionStorage.setItem(collectionContextKey, JSON.stringify({ url: source.href, time: Date.now() })); } catch {}
  };
  const recalledCollection = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(collectionContextKey));
      const age = Date.now() - saved?.time;
      if (!Number.isFinite(age) || age < 0 || age > 60 * 60 * 1000) return null;
      return collectionSource(saved.url);
    } catch { return null; }
  };
  let chatForm;
  let chatObserver;
  let chatTrigger;
  document.addEventListener('shopify-chat:close', () => {
    const trigger = chatTrigger;
    chatTrigger = null;
    if (trigger?.isConnected && matchMedia('(max-width: 767px)').matches) {
      requestAnimationFrame(() => trigger.focus({ preventScroll: true }));
    }
  });
  const initialiseContactChat = () => {
    const intro = document.getElementById('DonglinContactStart');
    const form = intro?.closest('.contact-form');
    if (!form || form.dataset.dlChatPending) return;
    form.dataset.dlChatPending = 'true';
    customElements.whenDefined('shopify-chat').then(() => {
      const chat = document.querySelector('#chat-drawer shopify-chat');
      if (!chat || !form.isConnected) return;
      if (chatForm !== form) chatObserver?.disconnect();
      chatForm = form;
      form.dataset.dlChatReady = 'true';
      form.querySelectorAll('[data-dl-open-chat]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          chatTrigger = button;
          chat.setAttribute('open', '');
        });
      });
      if ('IntersectionObserver' in window) {
        chatObserver = new IntersectionObserver(entries => {
          document.documentElement.toggleAttribute('data-dl-contact-form-visible', entries.some(entry => entry.isIntersecting));
        });
        chatObserver.observe(form);
      } else {
        document.documentElement.setAttribute('data-dl-contact-form-visible', '');
      }
    });
  };
  const initialise = () => {
    const feedback = document.querySelector('main .contact-form__success, main .contact-form__error');
    if (feedback && !feedback.dataset.dlFeedbackReady) {
      feedback.dataset.dlFeedbackReady = 'true';
      requestAnimationFrame(() => {
        feedback.focus({ preventScroll: true });
        feedback.scrollIntoView({ block: 'center', behavior: 'instant' });
      });
    }
    const jump = document.querySelector('[data-dl-catalog-jump]');
    if (jump && !jump.dataset.ready) {
      const candidates = document.querySelectorAll('main [data-product-grid], main [data-serving-grid], main [data-set-grid], main .product-grid-container, main [id*="__product_list_"]');
      const grid = Array.from(candidates).find(node => node.getBoundingClientRect().width > 0 && node.querySelector('a[href*="/products/"]'));
      if (grid) {
        const target = grid.closest('.dl-catalog__anchor, .dl-sets__catalog') || grid;
        if (!target.id) target.id = 'DonglinBrowseProducts';
        target.classList.add('dl-browse-anchor');
        if (!target.hasAttribute('tabindex')) target.tabIndex = -1;
        jump.href = `#${target.id}`;
        jump.hidden = false;
        jump.dataset.ready = 'true';
        jump.addEventListener('click', () => requestAnimationFrame(() => target.focus({ preventScroll: true })));
      }
    }
    const back = document.querySelector('[data-dl-back]');
    if (back && !back.dataset.ready) {
      let source = collectionSource(document.referrer);
      if (source) rememberCollection(source);
      else if (contactReferrer()) source = recalledCollection();
      if (source) {
        back.href = source.href;
        back.textContent = config.backToCollection;
      }
      back.dataset.ready = 'true';
    }
    const returnLink = document.querySelector('[data-dl-return-source]');
    if (returnLink && !returnLink.dataset.ready) {
      const source = localSource(new URLSearchParams(location.search).get('source'));
      if (source) {
        returnLink.href = source.href;
        returnLink.textContent = config.backToSource;
        returnLink.hidden = false;
      }
      returnLink.dataset.ready = 'true';
    }
    initialiseContactChat();
  };
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
